import { WisoryButton } from 'components/WisoryButton';
import { BookingFormLayout } from 'pages/profile/components/Layout';
import { ProfileFooter } from 'pages/profile/components/Layout/components/ProfileFooter';
import { BookingFormContext } from 'pages/profile/context2';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { getAppConfigurations } from 'utils/environment-variables';

const config = getAppConfigurations();

export const ThankYouStep = () => {
  const { t } = useTranslation();
  const { state, setState, setStep } = useContext(BookingFormContext);

  const closeModal = () => {
    const closeBtn = document.querySelector<HTMLButtonElement>('[data-modal-close]');

    if (closeBtn) {
      setState((draft) => {
        setStep('select-time-or-suggest-timespans');
        draft.selectedSlot = undefined;
      });
      closeBtn.click();
    }
  };

  const renderContactInfoSection = () => {
    return (
      <div>
        <div className="text-black text-xl mb-2">{t('REACT_BOOKING_FRONTEND.booking2.contactHeadline1')}</div>
        <div className="text-black font-bold text-lg mb-2 font-openSans">
          {t('REACT_BOOKING_FRONTEND.booking2.contactHeadline2')}
        </div>
        <div className="flex flex-row gap-1">
          <span className="text-black font-openSans">{t('REACT_BOOKING_FRONTEND.booking2.contactPhone')}:</span>
          <a className="font-openSans anchor" href="tel:+46762317714">
            +46 76 231 77 14
          </a>
          <span>•</span>
          <a className="font-openSans anchor" href="mailto:happy@wisory.se">
            happy@wisory.se
          </a>
        </div>
        {state.customerInfo.isWisoryUser && (
          <>
            <div className="horizontal-line mt-12" />
            <div className="mt-4">
              <span className="text-black mr-1 font-openSans">
                {t('REACT_BOOKING_FRONTEND.booking2.contactMyWisory')}
              </span>
              <a className="font-openSans anchor" href={config.myWisoryUrl}>
                MyWisory!
              </a>
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <BookingFormLayout
      footer={
        <ProfileFooter className="flex justify-between">
          <div />
          <WisoryButton type="button" onClick={closeModal}>
            {t('REACT_BOOKING_FRONTEND.common.close')}
          </WisoryButton>
        </ProfileFooter>
      }
    >
      <div className="">
        <div className="mb-5 whitespace-pre-line text-black font-openSans font-bold text-2xl">
          {state.workflow === 'select-time' && t('REACT_BOOKING_FRONTEND.booking2.successSelectTimeTitle')}
          {state.workflow === 'suggest-timespans' && t('REACT_BOOKING_FRONTEND.booking2.successSuggestTimeTitle')}
        </div>
        <div className="mb-5 text-black font-libreBaskerville text-xl">
          {state.workflow === 'select-time' && t('REACT_BOOKING_FRONTEND.booking2.successSelectTimeDescription')}
          {state.workflow === 'suggest-timespans' && (
            <>
              <div className="font-bold font-openSans text-xl-22">
                {t('REACT_BOOKING_FRONTEND.booking2.successSuggestTimeDescription1')}
              </div>
              <div className="mt-6 mb-6 font-openSans">
                {t('REACT_BOOKING_FRONTEND.booking2.successSuggestTimeDescription2')}
              </div>
              <div className="">{t('REACT_BOOKING_FRONTEND.booking2.successSuggestTimeDescription3')}</div>
            </>
          )}
        </div>

        <div>{renderContactInfoSection()}</div>
      </div>
    </BookingFormLayout>
  );
};
